// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3af93be7","453":"6066b983","455":"91f24ad5","977":"5ff49343"}[chunkId] + ".chunk.js";
};